export default __webpack_public_path__ + "static/media/KH_Word_black.35039b8f.jpg";